export const tableStyle = {
    methods: {
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color: rgba(0, 0, 0, 0.02)";
            }
        },
        // 修改table border颜色
        tableRowStyle() {
            let rowStyleJson = {
                border: "rgba(0, 0, 0, 0.09)",
            };
            return rowStyleJson;
        },
    }
}



// WEBPACK FOOTER //
// ./src/common/mixin/table-style.js